export default __webpack_public_path__ + "static/media/res6.e0678fa2.PNG";